import { gql } from '@apollo/client';

export const UPDATE_OBJECT_MUTATION = gql`
  mutation UpdateObjectMutation($id: String!, $object: ObjectInput!) {
    updateObject(id: $id, object: $object) {
      ... on UpdateObjectSuccess {
        object {
          id
          createdAt
          updatedAt
          createdBy
          createdByName
          createdByEmail
          name
          description
          position
          geometry
          type
          siteId
          siteStatus
          groupId
          parentId
          parentName
          mapsVisible
          filled
          visibility
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
